<template>
	<v-container class="mt-4 px-5" fluid>
	<v-row>
	  	<v-col cols="12" >
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1"><v-icon left>mdi-fingerprint</v-icon>Reloj Checador</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn 
              class="mr-2" 
              small 
              dark 
              color="green"
              @click="exportar()">
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>

	  				<v-btn
              color="primary"
              dark
              @click="initialize"
              small
              rounded
            >
              Actualizar
            </v-btn>
	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row>
	  		  		<v-col cols="12" md="4" lg="2">
	  		  			<v-text-field
	  		  			  label="Fecha"
	  		  			  type="date"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  v-model="fecha"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  		<v-col cols="12" md="4" lg="2">
	  		  			<v-text-field
	  		  			  label="Fecha"
	  		  			  type="date"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  v-model="fechafin"
	  		  			></v-text-field>
	  		  		</v-col>

	  		  		<v-spacer></v-spacer>

	  		  		<v-col cols="12" md="6" lg="4">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="entradassalidas"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
			            item-key="identificador"
                  :show-expand="puedeDesplegarRelojChecador"
                  :expanded.sync="expanded"
                  @item-expanded="onExpandRow"
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>
							  
							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

								 <template v-slot:item.actions="{ item }">
							      <v-icon
								   		v-if="puedeEditarRelojChecador"
							        small
							        class="mr-2"
							        color="primary"
							        @click="editItem(item)"
							      >
							        mdi-pencil
							      </v-icon>
							    </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-3 grey lighten-4">
                      <div class="caption mb-2 font-weight-medium">Registros del día</div>
                      <v-progress-linear v-if="cargandoRegistros[item.identificador]" indeterminate color="primary" class="mb-2"></v-progress-linear>
                      <v-simple-table v-else dense>
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Hora</th>
                            <th>Fecha</th>
                            <th>Sucursal</th>
                            <th>Manual</th>
                            <th class="text-right">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="reg in (registrosPorFila[item.identificador] || [])" :key="reg.id">
                            <td>{{ reg.id }}</td>
                            <td>{{ formatHora(reg.hora || reg.hora_registro) }}</td>
                            <td>{{ formatFecha(reg.fecha) }}</td>
                            <td>{{ reg.sucursal || '—' }}</td>
                            <td>
                              <v-chip v-if="reg.manual" x-small dark color="primary">Manual</v-chip>
                            </td>
                            <td class="text-right">
                              <v-icon small class="mr-2" color="primary" @click="editRegistro(item, reg)">mdi-pencil</v-icon>
                              <v-icon small color="error" @click="confirmDeleteRegistro(item, reg)">mdi-delete</v-icon>
                            </td>
                          </tr>
                          <tr v-if="!(registrosPorFila[item.identificador] || []).length">
                            <td colspan="6" class="text-center caption">Sin registros</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </td>
                  </template>

							    <template v-slot:item.manual="{ item }">
							      <v-chip
							      	v-if="item.manual"
							        small
							        dark
							        class="mr-2"
							        color="primary"
							      >
							        Manual
							      </v-chip>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>

		<v-dialog
		v-model="dialog"
		max-width="500px"
		>
		<v-card>
			<v-card-title>
			<span class="text-h5">Actualizar Asistencias</span>
			</v-card-title>

			<v-card-text>
			<v-container>
				<v-row>
				<v-col cols="12" md="6">   
					<v-text-field 
						v-model="editedItem.entrada" 
						label="Hora Entrada:" 
						dense 
						type="time"
						filled
						hide-details
					>
					</v-text-field>
			    </v-col>

				<v-col cols="12" md="6">   
					<v-text-field 
						v-model="editedItem.salida" 
						label="Hora Salida:" 
						dense 
						type="time"
						filled
						hide-details
						:disabled="editedItem.entrada == null || editedItem.entrada == ''"
					>
					</v-text-field>
			    </v-col>

				<v-col cols="12" md="6" >
                <label>Fecha:</label>
					<v-text-field
					filled
					single-line
					label="Fecha"
					type="date"
					hide-details
					v-model="fechainsert"
					dense
					clearable
					></v-text-field>
               </v-col>
			   <v-col cols="12" md="6" >
			   <label>Sucursal:</label>
					<v-autocomplete
						label="Plantel"
						id="id"
						filled
						dense
						single-line
						hide-details
						v-model="editedItem.id_sucursal[0]"
						:items="planteles"
						item-text="plantel"
						item-value="id_plantel"
						clearable
					></v-autocomplete>
				</v-col>

				</v-row>
			</v-container>
			</v-card-text>

			<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="blue darken-1"
				text
				@click="close"
			>
				Cancelar
			</v-btn>
			<v-btn
				color="blue darken-1"
				class="elevation-6"
				dark
				@click="save"
			>
				Guardar
			</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>

    <v-dialog v-model="dialogRegistro" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h6">Editar registro</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedRegistro.hora"
                label="Hora"
                dense
                type="time"
                filled
                hide-details
                step="1"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedRegistro.fecha"
                label="Fecha"
                dense
                type="date"
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="editedRegistro.id_sucursal"
                :items="planteles"
                item-text="plantel"
                item-value="id_plantel"
                label="Sucursal"
                filled
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="editedRegistro.motivo"
                label="Motivo (obligatorio)"
                filled
                dense
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-1" @click="dialogRegistro = false">Cancelar</v-btn>
          <v-btn dark color="blue darken-1" :disabled="!motivoValido(editedRegistro.motivo)" @click="saveRegistro">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="460px">
      <v-card>
        <v-card-title class="text-h6">Eliminar registro</v-card-title>
        <v-card-text>
          <p class="mb-3">Esta acción borra el registro de forma permanente.</p>
          <v-textarea
            v-model="deleteMotivo"
            label="Motivo (obligatorio)"
            filled
            dense
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn dark color="error" :disabled="!motivoValido(deleteMotivo)" @click="deleteRegistro">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	  </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import XLSX            from 'xlsx'


  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

	  planteles:[],

      // Filtros: 
      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
	  	fechainsert: '',

		  dialog: false,
		  editedIndex: -1,

      editedItem: {
      	entrada: '',
				fecha: '',
				id: 0,
				id_sucursal: 0,
				id_usuario: 0,
				idchecador: 0,
				nombre_completo: '',
				plantel: '',
				puesto: '',
				salida: '',
                sucursal_registro: 0,
      },

      defaultItem: {
        entrada: '',
				fecha: '',
				id: 0,
				id_sucursal: 0,
				id_usuario: 0,
				idchecador: 0,
				nombre_completo: '',
				plantel: '',
				puesto: '',
				salida: '',
                sucursal_registro: 0,
      },

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      entradassalidas: [],
      expanded: [],
      registrosPorFila: {},
      cargandoRegistros: {},
      puedeDesplegarRelojChecador: false,
      dialogRegistro: false,
      dialogDelete: false,
      filaExpandida: null,
      editedRegistro: {
        id: 0,
        hora: '',
        fecha: '',
        id_sucursal: null,
        motivo: '',
      },
      deleteMotivo: '',
      deleteRegistroId: null,
      headers: [
        { text: 'ID'               , value: 'id'                 },
        { text: 'Empleado'         , value: 'nombre_completo'    },
        { text: 'Registró en:'     , value: 'sucursal_registro'  },
        { text: 'Fecha'            , value: 'fecha'              },
        { text: 'Entrada'          , value: 'entrada'            },
        { text: 'Salida'           , value: 'salida'             },
        { text: 'Manual'           , value: 'manual'             },
				{ text: 'Actualizar'       , value: 'actions'            },
      ],
    }),

    async created () {
    	console.log( this.getdatosUsuarioERPERP.id_plantel )
      await this.cargarPermisoDesplegar()
      await this.initialize()
	  	await this.getPlanteles()
    },

    computed:{
      ...mapGetters('login',['getdatosUsuarioERPERP']),
      puedeEditarRelojChecador() {
        const iderp = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp);
        const idpuesto = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto);

        return [334, 966, 1333, 954, 2120].includes(iderp) || idpuesto === 108;
      },
    },

    methods: {
      motivoValido (motivo) {
        return String(motivo || '').trim().length >= 5
      },
      puestoVisiblePara568 (puesto) {
        const n = String(puesto || '')
          .toLowerCase()
          .replace(/á/g, 'a')
          .replace(/é/g, 'e')
          .replace(/í/g, 'i')
          .replace(/ó/g, 'o')
          .replace(/ú/g, 'u')
          .trim()
        const permitidos = [
          'jefe de operaciones',
          'coordinador de operaciones',
          'gerente de operaciones',
          'coord. oper. inbi',
          'coordo. oper. fast',
          'asistente de jefe de operaciones',
          'recepcion',
          'recepcionista vespertina',
          'encargada de sucursal',
          'encargada sucursal',
          'ventas',
          'coordinador de ventas',
          'supervisor ventas',
          'teacher',
          'teacher capacitacion',
          'auxiliar de mantenimiento',
          'coordinador de mantenimiento',
          'mtto',
        ]
        return permitidos.indexOf(n) !== -1
      },
      formatHora (hora) {
        if (!hora) return ''
        return String(hora).slice(0, 8)
      },
      formatFecha (fecha) {
        if (!fecha) return ''
        return String(fecha).slice(0, 10)
      },
      cargarPermisoDesplegar () {
        return this.$http.get('usuarios.reloj.checador.permiso').then(response => {
          this.puedeDesplegarRelojChecador = !!(response.data && response.data.puede_gestionar)
        }).catch(() => {
          this.puedeDesplegarRelojChecador = false
        })
      },
      onExpandRow ({ item, value }) {
        if (!value || !this.puedeDesplegarRelojChecador) return
        this.cargarRegistrosFila(item)
      },
      cargarRegistrosFila (item) {
        const key = item.identificador
        this.$set(this.cargandoRegistros, key, true)
        return this.$http.post('usuarios.reloj.checador.registros', {
          id_trabajador: item.id,
          fecha: this.formatFecha(item.fecha),
        }).then(response => {
          this.$set(this.registrosPorFila, key, response.data || [])
        }).catch(error => {
          this.validarError(error.response && error.response.data && error.response.data.message)
        }).finally(() => {
          this.$set(this.cargandoRegistros, key, false)
        })
      },
      editRegistro (fila, reg) {
        this.filaExpandida = fila
        this.editedRegistro = {
          id: reg.id,
          hora: this.formatHora(reg.hora || reg.hora_registro).slice(0, 8),
          fecha: this.formatFecha(reg.fecha),
          id_sucursal: reg.id_sucursal,
          motivo: '',
        }
        this.dialogRegistro = true
      },
      confirmDeleteRegistro (fila, reg) {
        this.filaExpandida = fila
        this.deleteRegistroId = reg.id
        this.deleteMotivo = ''
        this.dialogDelete = true
      },
      saveRegistro () {
        if (!this.motivoValido(this.editedRegistro.motivo)) return
        this.cargar = true
        this.$http.post('usuarios.reloj.checador.registro.update', this.editedRegistro).then(() => {
          this.validarSuccess('Registro actualizado')
          this.dialogRegistro = false
          if (this.filaExpandida) this.cargarRegistrosFila(this.filaExpandida)
          this.initialize()
        }).catch(error => {
          this.validarError(error.response && error.response.data && error.response.data.message)
        }).finally(() => { this.cargar = false })
      },
      deleteRegistro () {
        if (!this.motivoValido(this.deleteMotivo)) return
        this.cargar = true
        this.$http.post('usuarios.reloj.checador.registro.delete', {
          id: this.deleteRegistroId,
          motivo: this.deleteMotivo,
        }).then(() => {
          this.validarSuccess('Registro eliminado')
          this.dialogDelete = false
          if (this.filaExpandida) this.cargarRegistrosFila(this.filaExpandida)
          this.initialize()
        }).catch(error => {
          this.validarError(error.response && error.response.data && error.response.data.message)
        }).finally(() => { this.cargar = false })
      },
      initialize () {
      	this.cargar = true
        this.entradassalidas = []

        const payload = {
        	fecha:    this.fecha,
        	fechafin: this.fechafin
        }

        return this.$http.post('usuarios.entradas.all', payload).then(response=>{

        	if( [11,12,68, 43, 58, 72, 85 ].includes( this.getdatosUsuarioERPERP.idpuesto ) || ( [18,19,88].includes( this.getdatosUsuarioERPERP.idpuesto ) && [ 568, 161, 626, 382, 1196, 2155 ].includes( this.getdatosUsuarioERPERP.iderp ) )){

        		if( this.getdatosUsuarioERPERP.idpuesto == 88  ){

        			this.entradassalidas = response.data.filter( el => el.plantel != 'CORPORATIVO' )

        		}else{

        			this.entradassalidas = response.data
        		
        		}

        	}else{

        		// 10 = (ya restringido) | 52 = Programador de producto → solo sus horas
        		if( [10, 52].includes( this.getdatosUsuarioERPERP.idpuesto ) ){
        			this.entradassalidas = response.data.filter( el => { return el.id_usuario == this.getdatosUsuarioERPERP.iderp })
        		}else{

        			if( this.getdatosUsuarioERPERP.id_plantel == 10015 ){
        				this.entradassalidas = response.data.filter( el => { return el.id_usuario == this.getdatosUsuarioERPERP.iderp || ( el.id_sucursal.includes( 25 ) || el.id_sucursal.includes( 10015 )) })
        			}else{
        				this.entradassalidas = response.data.filter( el => { return el.id_usuario == this.getdatosUsuarioERPERP.iderp || el.id_sucursal.includes( this.getdatosUsuarioERPERP.id_plantel ) })
        			}
        		}
        	}

        	if( [2268].includes( this.getdatosUsuarioERPERP.iderp )){

        		this.entradassalidas = response.data

        	}

        	if( [7,1794].includes( this.getdatosUsuarioERPERP.iderp )){

        		this.entradassalidas = response.data

        	}

			if( [1312,2492,21,2120,3015,1177].includes( this.getdatosUsuarioERPERP.iderp )){

				this.entradassalidas = response.data

			}

			// Usuario 568: solo chequeos de operaciones, recepción, encargadas, ventas,
			// asistente de jefe de operaciones, teacher y mantenimiento.
			if (Number(this.getdatosUsuarioERPERP.iderp) === 568) {
				this.entradassalidas = response.data.filter(el => this.puestoVisiblePara568(el.puesto))
			}

			// Valeria Monroy Silva (iderp 2548): también ve los chequeos de María Esther Segura Canales (605).
			if (Number(this.getdatosUsuarioERPERP.iderp) === 2548) {
				const ya = {}
				this.entradassalidas.forEach(el => {
					ya[String(el.id) + '|' + String(el.fecha)] = true
				})
				response.data.forEach(el => {
					const nombre = String(el.nombre_completo || '').toUpperCase()
					const esMariaEsther = (Number(el.id) === 605 || Number(el.id_usuario) === 605)
						&& nombre.indexOf('ESTHER') !== -1
						&& nombre.indexOf('SEGURA') !== -1
					const key = String(el.id) + '|' + String(el.fecha)
					if (esMariaEsther && !ya[key]) {
						this.entradassalidas.push(el)
						ya[key] = true
					}
				})
			}


        	let k = 0
        	for( const i in this.entradassalidas ){
        		this.entradassalidas[i]['identificador'] = k
        		k++
        	}

        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

	   editItem (item) {
        this.editedIndex = this.entradassalidas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

	  close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

      exportar(){
        let data = XLSX.utils.json_to_sheet(this.entradassalidas)
        const workbook = XLSX.utils.book_new()
        const filename = 'entradas_salidas'
        XLSX.utils.book_append_sheet(workbook, data, filename)

        var wbout = XLSX.write(workbook, {
          bookType: 'xls',
          bookSST: false,
          type: 'binary'
        });

        const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
        
        let formData = new FormData();
        // //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file',file);
        // /*getDatosRiesgo the form data*/

        this.$http.post('pdfs',formData).then(response=> {
          window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
        }).catch(error=> {
          console.log(error);
        });
      },

	   save () {
				this.editedItem.manual = 1
				this.editedItem.sucursal_registro = this.editedItem.id_sucursal
				console.log('id_sucursal', this.editedItem.id_sucursal)
				console.log('sucursal_registro', this.editedItem.sucursal_registro)
        if (this.editedIndex > -1) {

					this.editedItem.fechainsert = this.fechainsert;
		        this.cargar        = true
	          this.$http.post('update.entradassalidas',  this.editedItem).then(response=>{
	        	this.validarSuccess('Datos grabados correctamente')
	        	this.initialize()
        		this.close()
						this.fechainsert = ''
	        	this.cargar        = false
	        }).catch( error =>{
	          this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })

        } else {
        	// Activamos el loader
	        this.cargar        = true
	        // Lo mandapos por el EP
          this.$http.post('add.proyectos', this.editedItem).then(response=>{
          	this.validarSuccess('Datos grabados correctamente')
          	this.initialize()
        		this.close()
	        	this.cargar        = false
	        }).catch( error =>{
	          this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })
        }
      },

	  getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
        	this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },
    },
  }
</script>


